import { useCallback } from "react";
import { useAppSelector } from "@/store/hooks";
import { isFeatureAllowed } from "@/security/features.catalog";
import { OpenUpgradePlanPubSub } from "@utils/pubsubs/PubSub";

/**
 * Acceso a features según el plan (SuscriptionType) del tenant.
 * Independiente del ACL de roles (disabled_acl no interviene aquí).
 */
const useFeatureAccess = () => {
    const planFeatures = useAppSelector((state) => state.suscription.planFeatures);

    const hasFeature = useCallback((featureId: string): boolean => {
        return isFeatureAllowed(planFeatures, featureId);
    }, [planFeatures]);

    /** Ejecuta fn si el plan incluye el feature; si no, abre el modal de upgrade. */
    const guardFeature = useCallback(<T,>(featureId: string, fn: () => T, featureLabel?: string): T | undefined => {
        if (isFeatureAllowed(planFeatures, featureId)) {
            return fn();
        }
        OpenUpgradePlanPubSub.publish({ featureLabel, featureId });
        return undefined;
    }, [planFeatures]);

    return { hasFeature, guardFeature };
};

export default useFeatureAccess;
